
import { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { Auth } from "@/api";
import { AuthenticationContext } from "@/context";
import { getThemeURL } from "@/utils";

import { ProviderCreate } from "./Create";
import { ProviderUpdate } from "./Update";
import styles from "./Account.module.scss";


export const Account: FC = () => {
  const navigate = useNavigate();

  const { isUserLoggedIn, getUser } = useContext(AuthenticationContext);
  const [user, setUser] = useState<Auth.GetUserResponse>();

  const checkUser = async () =>{
    setUser(await getUser());
  };

  useEffect(() => {
    // Must be logged in to access page
    if (!isUserLoggedIn()) {
      navigate(getThemeURL("LOGIN"));
    }
    checkUser();
  },
  [isUserLoggedIn, getUser, navigate],
  );

  return (
    <div className={styles.AccountContainer}>
      {user && !user.provider_management_id
        && <ProviderCreate refreshUser={checkUser} user={user} />
      }
      {user && user.provider_management_id
        && <ProviderUpdate />
      }
    </div>
  );
};

export default Account;
